document.addEventListener('DOMContentLoaded', function () {
  let intervalId;

  function attachSizeButtonListeners() {
    const sizeButtons = document.querySelectorAll('.product-card__size-button');
    if (!sizeButtons.length) return false;

    sizeButtons.forEach(button => {
      if (button.dataset.listenerAdded) return; // Prevent double attachment
      button.dataset.listenerAdded = true;

      button.addEventListener('click', function () {
        const variantId = this.dataset.variantId;
        if (!variantId) return;

        this.classList.add('active');
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(response => {
            if (!response.ok) throw new Error('Failed to add to cart');
            return response.json();
          })
          .then(data => {
            // console.log('✅ Added to cart:', data);

            // Trigger cart events
            document.dispatchEvent(new CustomEvent('cart:change', {
              detail: { baseEvent: 'variant:add', cart: { sections: {} }, onSuccessDo: 'force_open_drawer' }
            }));
            document.dispatchEvent(new Event('cart:refresh'));
          })
          .catch(error => console.error('❌ Error adding to cart:', error))
          .finally(() => {
            this.classList.remove('active');
            this.disabled = false;
          });
      });
    });

    return true; // Successfully attached
  }

  // Start interval to check if size buttons exist
  intervalId = setInterval(() => {
    const attached = attachSizeButtonListeners();
    if (attached) clearInterval(intervalId); // Stop once buttons are found & listeners attached
  }, 300);
  

  // Shopify cart events — re-run initSlider or your JS when drawer updates
  ['cart:updated', 'cart:drawer:open', 'cart:drawer:updated'].forEach(evt => {
    document.addEventListener(evt, () => {
      // initSlider();
      // Optional: reattach listeners if new product cards are added dynamically
      attachSizeButtonListeners();
    });
  });

  // Fallback — observe cart drawer DOM for dynamic changes
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      // initSlider();
      attachSizeButtonListeners();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  const cartDot = document.querySelector('cart-dot');
  if (!cartDot) return;

  // Function to update cart count
  function updateCartDot() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const count = cart.item_count;
        cartDot.textContent = count > 0 ? count : '0';
        cartDot.classList.toggle('is-visible', count > 0);
      });
  }

  // When product is added to cart (Shopify AJAX)
  document.addEventListener('cart:change', updateCartDot);

  // Also update after page load or when user returns
  window.addEventListener('pageshow', updateCartDot);

  // OPTIONAL: update immediately after add-to-cart fetch
  document.body.addEventListener('click', (e) => {
    if (e.target.closest('form[action^="/cart/add"]')) {
      setTimeout(updateCartDot, 800); // small delay for fetch to complete
    }
  });

  // Initial load
  updateCartDot();
});


$(document).ready(function () {
  function initFooterToggle() {
    // Mobile
    if ($(window).width() <= 768) {

      // Hide all lists initially
      $(".footer .footer__block--links ul").hide();

      // Remove old bindings and rebind
      $(".footer .footer-item__title").off("click").on("click", function () {

        // Correct selector: find UL inside the same block
        $(this)
          .closest(".footer__block")
          .find(".footer__block--links ul")
          .slideToggle(300);

        $(this).toggleClass("is-active");
      });

    } else {
      // Desktop
      $(".footer .footer__block--links ul").show();     // always shown
      $(".footer .footer-item__title").off("click");     // no toggle
      $(".footer-item__title").removeClass("is-active"); // reset icons
    }
  }

  // Run on load
  initFooterToggle();

  // Re-run on resize
  $(window).on("resize", function () {
    initFooterToggle();
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Function to attach click listeners to size variants
  var attachSizeListeners = function() {
    const sizeVariants = document.querySelectorAll('.size-variant');

    sizeVariants.forEach(variant => {
      if (!variant.dataset.listenerAdded) {
        variant.addEventListener('click', function () {
          // Remove active class from all size variants
          sizeVariants.forEach(v => v.classList.remove('active'));

          // Add active class to clicked variant
          this.classList.add('active');
        });

        variant.dataset.listenerAdded = 'true'; // mark listener as added
      }
    });
  };

  // Function to initialize everything
  var initSizeVariants = function() {
    // Wait until size variants exist
    var checkExist = setInterval(function () {
      if (document.querySelectorAll('.size-variant').length > 0) {
        attachSizeListeners();
        clearInterval(checkExist);
      }
    }, 200);
  };

  // Initial attach
  initSizeVariants();

  // Shopify cart drawer events — re-attach on updates
  document.addEventListener('cart:updated', attachSizeListeners);
  document.addEventListener('cart:drawer:open', attachSizeListeners);
  document.addEventListener('cart:drawer:updated', attachSizeListeners);

  // Fallback — observe DOM for cart drawer changes
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      attachSizeListeners();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
});





document.addEventListener('DOMContentLoaded', function () {
  function initSlider() {
    const sliders = document.querySelectorAll('#complementary-slider');

  sliders.forEach((slider) => {
    if (slider.classList.contains('splide-initialized')) return;

    const splide = new Splide(slider, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      arrows: false,
      pagination: false,
      breakpoints: { 1024: { perPage: 2 } },
    }).mount();

    // Create custom arrows container
    const arrowsWrapper = document.createElement('div');
    arrowsWrapper.classList.add('custom-arrows');

    // Create Prev button
    const prevBtn = document.createElement('button');
    prevBtn.classList.add('custom-prev');
    prevBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path d="M7.91872 14.5664L0.847656 7.49536L7.91872 0.424294" stroke="black" stroke-width="1.2"/>
      </svg>
    `;

    // Create Next button (mirrored arrow)
    const nextBtn = document.createElement('button');
    nextBtn.classList.add('custom-next');
    nextBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none" style="transform: rotate(180deg);">
        <path d="M7.91872 14.5664L0.847656 7.49536L7.91872 0.424294" stroke="black" stroke-width="1.2"/>
      </svg>
    `;

    // Append buttons to wrapper
    arrowsWrapper.appendChild(prevBtn);
    arrowsWrapper.appendChild(nextBtn);

    // Insert arrows after slider
    slider.parentNode.insertBefore(arrowsWrapper, slider.nextSibling);

    // Add click events
    prevBtn.addEventListener('click', () => splide.go('<'));
    nextBtn.addEventListener('click', () => splide.go('>'));
  

    // Store Splide instance on element for reference
    slider._splide = splide;

    // Handle size buttons inside THIS slider only
    slider.addEventListener('pointerdown', (e) => {
      const btn = e.target.closest('.product-card__size-button');
      if (!btn) return;

      splide.Components.Drag.disable(true); // disable drag
      e.stopPropagation(); // stop drag event from bubbling
    }, { passive: true });

    const reEnable = () => {
      splide.Components.Drag.disable(false); // re-enable drag
    };
    slider.addEventListener('pointerup', reEnable);
    slider.addEventListener('pointercancel', reEnable);
    slider.addEventListener('pointerleave', reEnable);

    // Prevent click events from triggering slider drag
    slider.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-card__size-button');
      if (btn) e.stopPropagation();
    });

    $('.product-card__size-button').bind('swipeLeft swipeRight', function(event) {
        event.stopPropagation();
    });

    slider.classList.add('splide-initialized');

  });
  }

  // Initial check
  const checkExist = setInterval(function () {
    if (document.querySelector('#complementary-slider')) {
      initSlider();
      clearInterval(checkExist);
    }
  }, 300);

  // Detect cart drawer updates (Shopify uses custom events)
  document.addEventListener('cart:updated', initSlider);
  document.addEventListener('cart:drawer:open', initSlider);
  document.addEventListener('cart:drawer:updated', initSlider);

  // Fallback — observe DOM for cart drawer content changes
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      initSlider();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
  
});




document.addEventListener('DOMContentLoaded', function () {
  var checkSlider = setInterval(function () {
    var sliderEl = document.querySelector('#product-recommendations-slider');
    if (sliderEl && typeof Splide !== 'undefined') {
      clearInterval(checkSlider);

      var splide = new Splide('#product-recommendations-slider', {
        type: 'slide',
        perPage: 4,
        arrows: false,
        pagination: false,
        breakpoints: {
          1024: { perPage: 3 },
          768: { perPage: 2 },
        },
      });

      splide.mount();

      // Store Splide instance on element for reference
      sliderEl._splide = splide;

      // Handle size buttons inside THIS slider only
      sliderEl.addEventListener(
        'pointerdown',
        (e) => {
          const btn = e.target.closest('.product-card__size-button');
          if (!btn) return;

          // Disable drag when pressing size button
          splide.Components.Drag.disable(true);
          e.stopPropagation();
        },
        { passive: true }
      );

      const reEnable = () => {
        splide.Components.Drag.disable(false); // Re-enable drag
      };

      // Restore drag when pointer is released or leaves
      sliderEl.addEventListener('pointerup', reEnable);
      sliderEl.addEventListener('pointercancel', reEnable);
      sliderEl.addEventListener('pointerleave', reEnable);

      // Prevent click on size buttons from triggering drag
      sliderEl.addEventListener('click', (e) => {
        const btn = e.target.closest('.product-card__size-button');
        if (btn) e.stopPropagation();
      });
    }
  }, 300); // checks every 300ms
});




document.addEventListener('DOMContentLoaded', function () {
  var checkExist = setInterval(function () {
    var slider = document.querySelector('.similar-style-slider');
    if (slider && typeof Splide !== 'undefined') {
      clearInterval(checkExist);

      // Initialize Splide
      var splide = new Splide(slider, {
        type: 'slide',
        perPage: 4,
        pagination: false,
        arrows: false,
        breakpoints: {
          1024: { perPage: 3 },
          768: { perPage: 2 },
        },
      }).mount();

      // Store Splide instance for reference
      slider._splide = splide;

      // Handle size buttons inside THIS slider only
      slider.addEventListener(
        'pointerdown',
        (e) => {
          const btn = e.target.closest('.product-card__size-button');
          if (!btn) return;

          // Disable drag
          splide.Components.Drag.disable(true);
          e.stopPropagation();
        },
        { passive: true }
      );

      const reEnable = () => {
        splide.Components.Drag.disable(false); // Re-enable drag
      };

      // Restore drag when pointer is released or leaves
      slider.addEventListener('pointerup', reEnable);
      slider.addEventListener('pointercancel', reEnable);
      slider.addEventListener('pointerleave', reEnable);

      // Prevent click events on size buttons from triggering drag
      slider.addEventListener('click', (e) => {
        const btn = e.target.closest('.product-card__size-button');
        if (btn) e.stopPropagation();
      });
    }
  }, 300);
});


document.addEventListener('DOMContentLoaded', function () {
  var checkExist = setInterval(function () {
    var triggerBox = document.querySelector('.my-size-box');
    var targetButton = document.querySelector('.ks-chart-container button.sizing-chart-modal-button');

    if (triggerBox && targetButton) {
      clearInterval(checkExist);

      triggerBox.addEventListener('click', function () {
        targetButton.click();
      });
    }
  }, 200);

});

document.addEventListener('DOMContentLoaded', function () {
  var checkExist = setInterval(function () {
    var trigger = document.querySelector('.show-size-guide');
    var targetButton = document.querySelector('.ks-chart-container button.sizing-chart-modal-button');

    if (trigger && targetButton) {
      clearInterval(checkExist); // stop checking

      // Add click event to trigger
      trigger.addEventListener('click', function () {
        targetButton.click();
      });
    }
  }, 100); // check every 100ms
});



document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.querySelector('.header .header__primary-nav button');
  const sidebar = document.querySelector('.custom-sidebar');
  const body = document.body;

  if (!toggleBtn || !sidebar) return; // safety check

  toggleBtn.addEventListener('click', () => {
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

    // Toggle aria-expanded
    toggleBtn.setAttribute('aria-expanded', !isExpanded);

    // Toggle sidebar active class
    sidebar.classList.toggle('active', !isExpanded);

    // Toggle body hidden class
    body.classList.toggle('overflow-hidden', !isExpanded);
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const mediaItems = document.querySelectorAll(
      ".template-product .product-gallery .product-gallery__media"
    );

    // if elements found
    if (mediaItems.length > 0) {
      clearInterval(interval); // stop checking

      mediaItems.forEach((item) => {
        item.addEventListener("click", function () {
          const zoomBtn = document.querySelector(".product-gallery__zoom-button");
          if (zoomBtn) zoomBtn.click();
        });
      });
    }
  }, 300); // check every 300ms
});



const observer = new MutationObserver(() => {
  const sizeBtns = document.querySelectorAll(".product-card__size-button");

  sizeBtns.forEach(btn => {
    if (btn.dataset.listenerAdded) return; // prevent duplicate listeners
    btn.dataset.listenerAdded = "true";

    btn.addEventListener("click", async function () {
      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (res.ok) {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          console.log("Added:", variantId);
        }

        document.dispatchEvent(new CustomEvent('cart:change', {
              detail: { baseEvent: 'variant:add', cart: { sections: {} }, onSuccessDo: 'force_open_drawer' }
            }));
            document.dispatchEvent(new Event('cart:refresh'));

      } catch (err) {
        console.error(err);
      }
    });
  });
});

// Watch body for new elements (like recommendations)
observer.observe(document.body, {
  childList: true,
  subtree: true
});



let variantChecker = setInterval(() => {
  const variants = document.querySelectorAll("#product-recommendations-slider .size-variant");

  if (variants.length > 0) {
    variants.forEach((item) => {
      item.addEventListener("click", () => {
        variants.forEach(v => v.classList.remove("active"));
        item.classList.add("active");
      });
    });

    clearInterval(variantChecker);
  }
}, 200);



document.addEventListener("DOMContentLoaded", () => {

  const handler = (e) => {
    const btn = e.target.closest(".custom-sortby-list .popover__value-option");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productList = document.querySelector("product-list");
    const sortValue = btn.getAttribute("value");
    if (!productList || !sortValue) return;

    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sortValue);
    history.pushState({}, "", url.toString());

    productList.classList.add("loading");

    fetch(url.toString())
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newProductList = doc.querySelector("product-list");

        if (newProductList) {
          productList.innerHTML = newProductList.innerHTML;
        }

        productList.classList.remove("loading");

        const allSortButtons = document.querySelectorAll(".custom-sortby-list .popover__value-option");
        allSortButtons.forEach(b => b.removeAttribute("aria-selected"));

        allSortButtons.forEach(b => {
          if(b.getAttribute("value") === sortValue) {
            b.setAttribute("aria-selected", "true");
          }
        });
      })
      .catch(err => console.error("AJAX sort error:", err));
  };

  // Works on all mobile devices
  document.addEventListener("click", handler, { passive: false });
  document.addEventListener("touchstart", handler, { passive: false });
});



document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.template-product .product-gallery');
  const zoomBtn = document.querySelector('.product-gallery__zoom-button');

  if (!gallery || !zoomBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      zoomBtn.style.display = entry.isIntersecting ? '' : 'none';
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '-100px 0px -100px 0px'
    }
  );

  observer.observe(gallery);
});

 (() => {
    const labelArrows = (arrows) => {
      const prev = arrows.querySelector('.custom-prev');
      const next = arrows.querySelector('.custom-next');

      if (prev && !prev.getAttribute('aria-label')) {
        prev.setAttribute('aria-label', 'Previous slide');
        prev.querySelector('svg')?.setAttribute('aria-hidden', 'true');
        prev.querySelector('svg')?.setAttribute('focusable', 'false');
      }

      if (next && !next.getAttribute('aria-label')) {
        next.setAttribute('aria-label', 'Next slide');
        next.querySelector('svg')?.setAttribute('aria-hidden', 'true');
        next.querySelector('svg')?.setAttribute('focusable', 'false');
      }
    };

    /* ── Patch any already-existing arrows ── */
    document.querySelectorAll('.custom-arrows').forEach(labelArrows);

    /* ── Watch for dynamically injected arrows ── */
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          /* The arrows wrapper itself was added */
          if (node.classList.contains('custom-arrows')) {
            labelArrows(node);
          }

          /* Arrows wrapper is inside a added subtree */
          node.querySelectorAll?.('.custom-arrows').forEach(labelArrows);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

   (() => {
    const fix = () => {
      const slides = document.querySelectorAll(
        '#complementary-slider-slide01, #complementary-slider-slide02'
      );
      slides.forEach((slide) => {
        slide.querySelectorAll('.product-card__media[aria-hidden="true"]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
      });
    };

    /* ── Keep retrying until the slider renders ── */
    const interval = setInterval(() => {
      const slide01 = document.querySelector('#complementary-slider-slide01');
      if (slide01) {
        fix();
        clearInterval(interval);
      }
    }, 100);

    /* ── Also watch for any DOM changes after that ── */
    new MutationObserver(fix).observe(document.body, {
      childList: true,
      subtree: true,
      attributeFilter: ['aria-hidden']
    });
  })();

   (() => {
    const getPageTitle = () => {
      const type = document.body.className;

      /* Home page → use shop name, not "shop.name | shop.name" */
      if (type.includes('template-index')) return '{{ shop.name }}';

      /* Cart & utility pages → hardcoded is cleaner */
      if (type.includes('template-cart'))  return 'Your Cart';
      if (type.includes('template-search')) return 'Search';
      if (type.includes('template-404'))   return 'Page Not Found';

      /* Everything else: strip " | Shop Name" from <title> */
      return document.title.split(/[|\-–]/)[0].trim() || '{{ shop.name }}';
    };

    const ensureH1 = () => {
      if (document.querySelector('h1')) return;

      const h1 = document.createElement('h1');
      h1.textContent = getPageTitle();
      h1.style.cssText = [
        'position:absolute',
        'width:1px',
        'height:1px',
        'padding:0',
        'margin:-1px',
        'overflow:hidden',
        'clip:rect(0,0,0,0)',
        'white-space:nowrap',
        'border:0'
      ].join(';');

      const main = document.getElementById('main') || document.querySelector('main');
      if (main) {
        main.insertBefore(h1, main.firstChild);
      } else {
        document.body.insertBefore(h1, document.body.firstChild);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ensureH1);
    } else {
      ensureH1();
    }
  })();

   (() => {
    const fixVariantA11y = () => {
      document.querySelectorAll('.variant-picker__option').forEach(option => {
        const legendEl = option.querySelector('legend');
        const valuesEl = option.querySelector('.variant-picker__option-values');

        if (!legendEl || !valuesEl) return;

        /* ── 1. Associate the legend with the radio group ── */
        if (!legendEl.id) {
          legendEl.id = 'vp-legend-' + Math.random().toString(36).slice(2, 7);
        }
        valuesEl.setAttribute('role', 'group');
        valuesEl.setAttribute('aria-labelledby', legendEl.id);

        /* ── 2. Mark out-of-stock inputs and labels ── */
        option.querySelectorAll('label.is-disabled').forEach(label => {
          /* Add visually hidden "(Out of stock)" inside the label */
          if (!label.querySelector('.a11y-oos')) {
            const srText = document.createElement('span');
            srText.className = 'a11y-oos sr-only';
            srText.textContent = ', out of stock';
            label.appendChild(srText);
          }

          /* Mark the input itself as disabled for AT */
          const input = document.getElementById(label.getAttribute('for'));
          if (input) {
            input.setAttribute('aria-disabled', 'true');
          }
        });
      });
    };

    /* ── Run on load ── */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixVariantA11y);
    } else {
      fixVariantA11y();
    }

    /* ── Re-run if the variant picker re-renders (e.g. color swatch changes) ── */
    const observer = new MutationObserver(() => fixVariantA11y());
    const observe = () => {
      const picker = document.querySelector('.variant-picker');
      if (picker) observer.observe(picker, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  })();

    (() => {
    const fixVariantA11y = () => {
      document.querySelectorAll('.variant-picker__option').forEach(option => {

        /* ── Out of stock: set aria-label directly on the input ── */
        option.querySelectorAll('label.is-disabled').forEach(label => {
          const sizeText = label.querySelector('span')?.textContent?.trim();
          const input = document.getElementById(label.getAttribute('for'));

          if (input && sizeText) {
            /* Screen readers announce this instead of the label text */
            input.setAttribute('aria-label', `${sizeText}, out of stock`);
            input.setAttribute('aria-disabled', 'true');
          }
        });

        /* ── Available options: ensure no stale aria-label ── */
        option.querySelectorAll('label:not(.is-disabled)').forEach(label => {
          const input = document.getElementById(label.getAttribute('for'));
          if (input) {
            input.removeAttribute('aria-label');   /* let label text speak naturally */
            input.removeAttribute('aria-disabled');
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixVariantA11y);
    } else {
      fixVariantA11y();
    }

    /* ── Re-run when variant picker re-renders (e.g. color change reloads sizes) ── */
    const observe = () => {
      const picker = document.querySelector('variant-picker');
      if (picker) {
        new MutationObserver(fixVariantA11y)
          .observe(picker, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  })();
  
   /* ── Size guide trigger accessibility ── */
  (function () {
    function fixTriggers() {
      /* All elements that open the kiwi modal */
      document.querySelectorAll('.show-size-guide, .my-size-box').forEach(function (el) {
        if (el.dataset.a11yTrigger) return; /* already fixed */

        /* p and div are not interactive — give them button semantics */
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-haspopup', 'dialog');

        /* Keyboard activation (Enter / Space) */
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            el.click();
          }
        });

        /* Remember this as the opener so focus returns on close */
        el.addEventListener('click', function () {
          window._kiwiOpener = el;
        });

        el.dataset.a11yTrigger = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixTriggers);
    } else {
      fixTriggers();
    }
  })();
  
  //button
  (function () {
    function fixTrigger() {
      document.querySelectorAll('.show-size-guide').forEach(function (el) {

        /* ── Immediately remove bad attributes ── */
        function stripOuter() {
          el.removeAttribute('role');
          el.removeAttribute('tabindex');
          el.removeAttribute('aria-haspopup');
          el.removeAttribute('data-a11y-trigger');
        }
        stripOuter();

        /* ── Keep removing them if any script re-adds them ── */
        new MutationObserver(stripOuter)
          .observe(el, { attributes: true, attributeFilter: ['role', 'tabindex', 'aria-haspopup'] });

        /* ── Only the summary needs the fix ── */
        var summary = el.querySelector('summary');
        if (!summary || summary.dataset.a11yTrigger) return;

        summary.setAttribute('aria-haspopup', 'dialog');
        summary.setAttribute('aria-label', 'Open size guide dialog');
        summary.dataset.a11yTrigger = 'true';

        summary.addEventListener('click', function () {
          window._kiwiOpener = summary;
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixTrigger);
    } else {
      fixTrigger();
    }
  })();

   (function () {
    var trapHandler = null;
    var modalReady  = false;

    function focusable(container) {
      return Array.from(container.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, ' +
        '[tabindex]:not([tabindex="-1"]), [role="button"]'
      ));
    }

    function isVisible(el) {
      if (!el) return false;
      var style = getComputedStyle(el);
      return style.display !== 'none' &&
             style.visibility !== 'hidden' &&
             style.opacity !== '0' &&
             el.offsetHeight > 0;
    }

    function onOpen(modal) {
      if (modal.dataset.a11yActive === 'true') return;
      modal.dataset.a11yActive = 'true';

      /* Dialog semantics */
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');

      var title = modal.querySelector('.modal-title-header');
      if (title) {
        title.id = 'ks-modal-title';
        modal.setAttribute('aria-labelledby', 'ks-modal-title');
      }

      /* Fix close span → button semantics */
      var closeBtn = modal.querySelector('[data-modal-close]');
      if (closeBtn && !closeBtn.dataset.a11yClose) {
        closeBtn.setAttribute('role', 'button');
        closeBtn.setAttribute('tabindex', '0');
        closeBtn.setAttribute('aria-label', 'Close size guide dialog');
        closeBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeBtn.click(); }
        });
        closeBtn.addEventListener('click', function () { onClose(modal); });
        closeBtn.dataset.a11yClose = 'true';
      }

      /* Fix table header cells */
      modal.querySelectorAll('tr').forEach(function (row) {
        row.querySelectorAll('.ks-table-header-cell').forEach(function (cell, i) {
          cell.setAttribute('role', 'columnheader');
          cell.setAttribute('scope', i === 0 ? 'row' : 'col');
        });
      });

      /* Move focus */
      setTimeout(function () {
        var first = closeBtn || focusable(modal)[0];
        if (first) first.focus();
      }, 80);

      /* Focus trap */
      trapHandler = function (e) {
        var items = focusable(modal);
        if (!items.length) return;
        if (e.key === 'Tab') {
          var first = items[0], last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        }
        if (e.key === 'Escape') {
          var cb = modal.querySelector('[data-modal-close]');
          if (cb) cb.click();
        }
      };
      document.addEventListener('keydown', trapHandler);
    }

    function onClose(modal) {
      if (modal.dataset.a11yActive !== 'true') return;
      modal.dataset.a11yActive = 'false';
      if (trapHandler) {
        document.removeEventListener('keydown', trapHandler);
        trapHandler = null;
      }
      if (window._kiwiOpener) {
        window._kiwiOpener.focus();
        window._kiwiOpener = null;
      }
    }

    /* ── Poll every 200ms — most reliable for 3rd-party modals ── */
    function startPolling(modal) {
      var wasVisible = false;
      setInterval(function () {
        var visible = isVisible(modal);
        if (visible && !wasVisible) {
          wasVisible = true;
          onOpen(modal);
        } else if (!visible && wasVisible) {
          wasVisible = false;
          onClose(modal);
        }
      }, 200);
    }

    function init() {
      /* Modal may already exist or be injected later by Kiwi */
      var modal = document.querySelector('.kiwi-sizing-modal');
      if (modal) {
        startPolling(modal);
        return;
      }

      /* Wait for Kiwi to inject the modal */
      new MutationObserver(function (_, obs) {
        var m = document.querySelector('.kiwi-sizing-modal');
        if (m) { obs.disconnect(); startPolling(m); }
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  document.querySelectorAll('.main-search__resource-item[aria-labelledby]').forEach(function (el) {
    el.removeAttribute('aria-labelledby');
  });

  //form
  

/* ---------------------------------------------------------------------------
   Two-step size picker inside product cards (e.g. Waist Size then Inseam).
   Step 1 buttons carry data-step1-value and only reveal the matching step 2
   group; only step 2 buttons carry data-variant-id, so nothing is added to the
   cart until both options have been chosen.
--------------------------------------------------------------------------- */
(function () {
  function showStepOne(wrap) {
    wrap.querySelectorAll('[data-step]').forEach(function (step) {
      step.hidden = step.getAttribute('data-step') !== '1';
    });
  }

  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('.product-card__size-button[data-step1-value]');
    if (stepBtn) {
      var wrap = stepBtn.closest('.product-card__sizes');
      if (!wrap) return;
      e.preventDefault();
      e.stopPropagation();
      var value = stepBtn.getAttribute('data-step1-value');
      wrap.querySelectorAll('[data-step]').forEach(function (step) {
        if (step.getAttribute('data-step') === '1') {
          step.hidden = true;
        } else {
          step.hidden = step.getAttribute('data-for') !== value;
        }
      });
      return;
    }

    var toggle = e.target.closest('.size-variant');
    if (toggle) {
      var card = toggle.closest('product-card') || toggle.closest('.product-card');
      var panel = card ? card.querySelector('.product-card__sizes[data-multi-step]') : null;
      if (panel) showStepOne(panel);
    }
  }, true);
})();
